import classNames from "classnames";
import { withTranslation } from "next-i18next";

function ProductGlobalRating({
  globalRating,
  ratingsCount,
  withRatingsCount = true,
  size = "24px",
  textSize = "font-size-normal",
  className,
  t,
}) {
  const stars = [...Array(5).keys()];

  function displayStars() {
    return stars.map((star) => {
      const starRating = star + 1;
      let fullStarWidth = "100%";

      if (Math.ceil(globalRating) < starRating) fullStarWidth = "0%";
      if (Math.floor(globalRating) < starRating && Math.ceil(globalRating) === starRating) {
        fullStarWidth = `${Math.ceil((globalRating - Math.floor(globalRating)) * 100)}%`;
      }

      return (
        <div
          key={`global-rating-full-star${star}`}
          className="product-review-star-container"
          style={{ width: size, height: size }}
        >
          <div className="product-review-star-empty" style={{ width: size, height: size }} />
          <div className="product-review-star-full" style={{ width: fullStarWidth, height: size }} />
        </div>
      );
    });
  }

  return (
    <div className={classNames("d-flex align-items-center", className)}>
      <div className="d-flex">
        {displayStars()}
      </div>

      {withRatingsCount && (
        <span className={classNames("text-gray", textSize)} style={{ lineHeight: "16px", marginTop: "3px" }}>
          {t("product:ratings_count", { count: ratingsCount })}
        </span>
      )}
    </div>
  );
}

export default withTranslation("product")(ProductGlobalRating);
